import { ADD_BOOKING, DELETE_BOOKING } from "./actionTypes";

const initialState ={
  bookings : []
}

const bookingReducer = (state=initialState, action)=>{
  switch (action.type) {
    case ADD_BOOKING:
      return {
        ...state,
        bookings: [...state.bookings, action.payload]
      };
    case DELETE_BOOKING:
      return {
        ...state,
        bookings: [...state.bookings.filter((b,i)=>i !== action.payload)]
      };
    default:
      return state;
  }
}


export default bookingReducer;